<template>
  <ArtistModuleWrapper
    :bgcolor="color"
    :class="touchState ? 'module-tapped' : 'not-tapped'"
  >
    <TitleBlock :TitleCopy="Data.title" :Color="color" />
    <TextureBg :Textures={textureArr}>
      <div class="image-wrapper">
        <div class="image">
          <LazyImg :src="Data.thumbnail"/>
        </div>
      </div>
      <a
        class="globe-wrapper"
        :href="Data.socials.website"
        target="_blank"
      >
        <LazyImg :src="'/imgs/icons/pink-globe.gif'" :fit="'cover'"/>
      </a>
      <LinkButton :Color="color" :Link="Data.socials.website"/>
    </TextureBg>
  </ArtistModuleWrapper>
</template>

<script>
import styled from 'vue-styled-components'
import Color from 'color'
import { colors, spacing, textures } from '@/styles/theme'
import * as _ from '@/styles/mixins'
import randomArrItem from '@/scripts/randomArrItem'
import LazyImg from '@/components/LazyImg'
import TextureBg from './TextureBg'
import TitleBlock from './TitleBlock'
import LinkButton from './LinkButton'

// STYLES
const props = {
  bgcolor: String
}

const ArtistModuleWrapper = styled('div', props)`
  ${_.absoluteTopFull};
  display: block;
  background-color: black;
  a.globe-wrapper {
    ${_.buttonCircle};
    transform: translateX(-8rem);
    filter: drop-shadow(0 0 5px ${props => Color(props.bgcolor).rotate(20)});
    bottom: 1rem;
    left: 1rem;
    ${_.media.desktop`
      width: 8rem;
      height: 8rem;
      bottom: 3rem;
      left: 2rem;
      transform: translateX(-15vmin);
    `}
  }
  .image-wrapper {
    ${_.absoluteTopFull};
    width: 100%;
    height: 100%;
    padding: ${spacing.thumb_pad};
    z-index: 100;
    will-change: transform;
    transform: rotate(0deg);
    transition: transform 25ms ease-in;
  }
  .image {
    position: relative;
    width: 100%;
    height: 100%;
    will-change: filter;
    transition: filter 500ms ease-in-out;
    filter: drop-shadow(0 0 0px ${props => Color(props.bgcolor).rotate(-90)});
  }
  .title {
    transform: rotate(2deg) translateY(-75%)!important;
    opacity: 1;
    z-index: 100;
    width: 120vw;
    left: -10vw;
    transition: transform 100ms ease-in-out;
    h4 {
      transform: scale(1)!important;
    }
    ${_.media.desktop`
      width: 60vw;
      left: -5vw;
    `}
  }
  &.module-tapped {
    .title {
      opacity: 1;
      transform: rotate(3deg) translateY(-42%)!important;
      h4 {
        filter: drop-shadow(0 0 30px ${props => Color(props.bgcolor).rotate(180)});
      }
    }
    .image {
      filter: drop-shadow(0 0 25px ${props => Color(props.bgcolor).rotate(0)});
    }
    .globe-wrapper,
    .link-button {
      transform: translateX(0);
    }
    .image-wrapper {
      transform: rotate(-2deg);
    }
  }
  ${_.media.hover`
    &:hover {
      .title {
        opacity: 1;
        transform: rotate(4deg) translateY(-38%)!important;
        h4 {
          filter: drop-shadow(0 0 80px ${props => Color(props.bgcolor).rotate(180)});
        }
      }
      .image {
        filter: drop-shadow(0 0 50px ${props => Color(props.bgcolor).rotate(0)});
      }
      .globe-wrapper,
      .link-button {
        transform: translateX(0);
      }
      .image-wrapper {
        transform: rotate(-5deg);
      }
    }
  `}
`

// VUE
export default {
  props: [
    'Data',
    'touchState'
  ],
  components: {
    ArtistModuleWrapper,
    LazyImg,
    TextureBg,
    TitleBlock,
    LinkButton
  },
  data () {
    return {
      color: randomArrItem(colors.fc),
      textureArr: textures.a
    }
  }
}
</script>
